<!--配置日志详情重写-->

<template>
  <Modal
    :visible.sync="visible"
    :title="
      `[${logData.deviceName}][${$t('integration.network_parameters')}] ${$t('integration.configuration_details')}-[${$timetransition(
        logData.createTime
      )}]`
    "
    append-to-body
  >
    <el-form label-position="right" label-width="150px" label-suffix="：">
      <el-form-item :label="$t('public.belong')">{{ url }}</el-form-item>
      <el-form-item :label="$t('integration.gateway_name_')">{{ detail.name }}</el-form-item>
      <el-form-item :label="$t('Mac')">{{ detail.name }}</el-form-item>
      <el-form-item :label="$t('public.config_status')"
        >{{ $t(configStatusConvert(detail.configStatus).title) }}
      </el-form-item>
      <el-form-item :label="$t('public.type')"
        >{{ $t(gatewayTypeConvert(detail.type).title) }}
      </el-form-item>

      <template v-if="detail.type === 3">
        <Config :json-content="JsonContent.content" mode="view"></Config>
      </template>
      <!--一代网络参数 通用-->
      <template v-else-if="JsonContent.content">
        <el-form-item :label="$t('Ext Pan ID')">
          <Modify :item="JsonContent.content.item.ext_pan_id"></Modify>
        </el-form-item>
        <el-form-item :label="$t('Join Attemp')">
          <Modify :item="JsonContent.content.item.channel_page"></Modify>
        </el-form-item>
        <el-form-item :label="$t('device.channel_mask')">
          <Modify :item="JsonContent.content.item.channel_mask"></Modify>
        </el-form-item>
      </template>
      <el-form-item :label="$t('public.command')"
        >{{ JsonContent.content && JsonContent.content.cmd }}
      </el-form-item>
      <el-form-item :label="$t('integration.configuration_steps')"
        >{{ $t(configStep[JsonContent.stepCode] &&
            configStep[JsonContent.stepCode].title) }}
      </el-form-item>
    </el-form>
  </Modal>
</template>

<script>
import { getConfigContent, getConfigLogContent } from '@/api/modules/deviceUrl'
import {
  configStatusConvert,
  configStep,
  equiTypeConvert,
  gatewayTypeConvert
} from '@/utils/convert'
import Config from '@/pages/equipment/gateway/modal/ConfigDialog/GenTwo/component/Config.vue'
import Modify from '@/pages/equipment/base/components/configInfo/Modify.vue'

export default {
  components: {
    Modify,
    Config
  },
  data () {
    return {
      visible: false,
      detail: {},
      logData: {},
      JsonContent: {}
    }
  },
  computed: {
    configStep () {
      return configStep
    },
    url () {
      let url = this.detail.scopeName
      if (this.detail.sceneName) {
        url += '/' + this.detail.sceneName
      }
      if (this.detail.carrierName) {
        url += '/' + this.detail.carrierName
      }
      return url
    }
  },
  methods: {
    gatewayTypeConvert,
    equiTypeConvert,
    configStatusConvert,
    open (data, logData) {
      this.visible = true
      this.detail = data
      this.logData = logData

      let param = null
      let httpUrl = null
      if (logData.responseDeviceConfigLogList) {
        param = 'configId'
        httpUrl = getConfigContent
      } else {
        param = 'configLogId'
        httpUrl = getConfigLogContent
      }

      httpUrl({ [param]: this.logData.id }, 'gateway').then(({ result }) => {
        if (result.content) {
          this.JsonContent = JSON.parse(result.content)
          this.JsonContent.content = JSON.parse(this.JsonContent.content)
          this.$set(this.JsonContent, 'stepCode', result.stepCode)
        } else if (result.deviceConfig) {
          this.JsonContent = result.deviceConfig
          this.JsonContent.content = JSON.parse(this.JsonContent.content)
          this.$set(this.JsonContent, 'stepCode', result.stepCode)
        }

        console.log(this.JsonContent)
      })
    }
  }
}
</script>
